<template>
    <div :class="[$style.__content]" >
         <div :class="[$style.__exit__confirm, successNoti == true ? [$style.__active] : '']">
            <div :class="[$style.__outer]">
            </div>
            <div :class="[$style.__exit__container]">
              
                <div :class="[$style.__body]">
                    <p><img :src="icon.success">{{$t('messages.rename.success')}}</p>
                </div>
               
            </div>
        </div>
        <Banner></Banner>
        <div :class="[$style.__main]" >
            <p :class="[$style.__intro]">{{$t('messages.rename.intro')}}</p>
            <form :class="['form-horizontal', $style.chat__form]"  @submit="checkForm">
                <InputName v-model="name"  @change="getGender"></InputName>
                
                <ErrorList :errors="errors"></ErrorList>
                <div :class="['row-livechat', $style.__button__container]">
                    <ButtonSubmit></ButtonSubmit>
                    <ButtonCancel @parentFunction="chatBack"></ButtonCancel>
                </div>
        </form>
        </div>
    </div>
</template>

<script>
    import Chathub from '@/apis/chathub';
    import Banner from '../blocks/Banner';
    import InputName from '../blocks/InputName';
    import ButtonSubmit from '../blocks/ButtonSubmit';
    import ButtonCancel from '../blocks/ButtonCancel';
    import ErrorList from '../blocks/ErrorList';
    import moment from 'moment'
    import Validator from '@/functions/Validator';

    let validator = new Validator;
    let chathubObject = new Chathub;


    export default {
        data () {
            return {
                token : '',
                name : '',
                errors : [],
                gender : '1',
                successNoti: {
                    type : Boolean,
                    default : false
                },
                icon : {
                    success : require('@/medias/images/icon/success.png')   
                },

            }
        },
        components : {
            Banner, InputName, ButtonSubmit, ButtonCancel, ErrorList
        },
        methods : {
            
            checkCookie : function () {
                var token = null;
                var room = null;
                var sso = this.$cookies.get("fpt_sso");
                
                if (this.$cookies.isKey('fpt_livechat')) {
                    token = this.$cookies.get("fpt_livechat").token;
                    room = this.$cookies.get("fpt_livechat").room;
                } 

                if (token != null && room != null) {
                    this.token = token;
                    this.room = room;
                } else {
                    // this.$router.replace('/');

                }
            },

            checkForm : function (event) {
                this.errors = [];

                if (this.name.trim().length <= 0) {
                    this.errors.push(this.$t("validator.name.null"));
                }

                if(validator.hasOnlySpecialCharater(this.name)) {
                    this.errors.push(this.$t("validator.name.special"));
                }
                
                if(validator.hasNumberCharacter(this.name)) {
                    this.errors.push(this.$t("validator.name.number"));
                }

                if(validator.maxCharacter(this.name) != true) {
                    this.errors.push(this.$t("validator.name.max", {max : validator.maxCharacter(this.name)}));
                }
                
                if(!this.errors.length) {
                    this.rename(this.name)
                }

                event.preventDefault()
            },

            
            rename : function (name) {
                chathubObject.changeName(this.token, name)
                .then(response => {
                    if (response.data.success) {
                        if (this.gender) {
                            chathubObject.setGender(this.token, this.gender)
                        }
                        this.successNoti = true;
                        var that = this
                        setTimeout(function() {
                        //your code to be executed after 1 second
                            that.$router.replace('/chat')
                        }, 2000);

                    }
                })
                .catch ( error => {
                    this.errors.push(this.$t("error.happend"));
                })
            },
            chatBack : function () {
                this.$router.replace('/chat')
            },
            getGender : function (event) {
                this.gender = event;
            }
            
        },
    
        created () {
            this.checkCookie()
        },
       
        mounted () {

            
        }
 
    }
</script>

<style lang="scss" module scoped>
    .__content {
        width:100%;
        .__main {
            padding: 15px 15px;
            min-height: 225px;
            position: relative;
            .__intro {
                margin-top:0.5rem !important;
                font-size:14px;
            }
        }
        .__button__container {
            position: relative;
            bottom: 0;
            margin-top: 40px !important;
        }

        .__exit__confirm {
            display: none;
            &.__active {
                display :block;
            }
            .__outer {
                background: #000;
                height: 100%;
                width : 100%;
                bottom : 0;
                position: absolute;
                z-index: 9999;
                opacity: 0.5;
            }
            .__exit__container {
                position: absolute;
                z-index: 10000;
                background : #fff;
                bottom : 40%;
                margin : 20px 25px;
                border-radius: 8px;
                padding : 8px 24px;
                .__header {
                    h5 {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                    }
                    margin-bottom: 20px
                }
                .__body {
                    img {
                        margin-right: 5px;
                    }
                    font-size: 13px !important;
                    font-style: normal;
                    line-height: 16px;
                    p {
                        margin-bottom: 0 !important;
                    }
                }
                .__footer {
                    .__btn {
                        font-size: 13px !important;
                        font-style: normal;
                        line-height: 16px;
                        width : 100%;
                    }
                }
            }
        }
    }
</style>